import { mount } from "@vue/test-utils";
import ArrowLeft from "@/components/core/ArrowLeft";

describe("ArrowLeft test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(ArrowLeft);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component ArrowLeft", () => {
    expect(wrapper).toBeDefined();
  });
});
